import { useEffect, useState } from 'react';
import { X, Building, Briefcase } from 'lucide-react';
import { User } from '../types';
import UserAvatar from './UserAvatar';
import './PRInfoModal.css';

interface PRInfoModalProps {
  isVisible: boolean;
  onClose: () => void;
  user: User;
}

export default function PRInfoModal({ isVisible, onClose, user }: PRInfoModalProps) {
  const [shouldRender, setShouldRender] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (isVisible) {
      setShouldRender(true);
      setTimeout(() => setIsAnimating(true), 50);
    } else {
      setIsAnimating(false);
      setTimeout(() => setShouldRender(false), 300);
    }
  }, [isVisible]);

  if (!shouldRender) return null;

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div 
      className={`pr-info-modal-overlay ${isAnimating ? 'visible' : ''}`}
      onClick={handleOverlayClick}
    >
      <div className="pr-info-modal-content">
        <div className="pr-modal-header">
          <h3>
            <Briefcase size={20} />
            PR情報
          </h3>
          <button className="pr-close-button" onClick={onClose}>
            <X size={24} />
          </button>
        </div>
        
        <div className="pr-modal-body">
          <div className="pr-user-info">
            <UserAvatar size={60} photoUrl={user.profilePhoto} />
            <div className="pr-user-details">
              <h4 className="pr-user-name">{user.name}</h4>
              <p className="pr-user-theme">{user.theme}</p>
            </div>
          </div>
          
          <div className="pr-info-section">
            <div className="pr-info-label">
              <Building size={16} />
              会社名
            </div>
            <div className="pr-info-content">
              {user.companyName ? (
                <p className="pr-info-text">{user.companyName}</p>
              ) : (
                <p className="pr-info-empty">未設定</p>
              )}
            </div>
          </div>
          
          <div className="pr-info-section">
            <div className="pr-info-label">
              <Briefcase size={16} />
              事業内容
            </div>
            <div className="pr-info-content">
              {user.businessContent ? (
                <p className="pr-info-text">{user.businessContent}</p>
              ) : (
                <p className="pr-info-empty">未設定</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}